import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../firebase';
import type { CommunityQuestionBase } from '../pages/Community/types/community-questions';
import type { Tool } from '../types/tools';
import type { SuccessStory } from '../types/success-stories';

export class PickersDataService {
  private static instance: PickersDataService;

  static getInstance(): PickersDataService {
    if (!PickersDataService.instance) {
      PickersDataService.instance = new PickersDataService();
    }
    return PickersDataService.instance;
  }

  // ==================== COMMUNITY QUESTIONS ====================

  async getAllCommunityQuestions(): Promise<CommunityQuestionBase[]> {
    try {
      const questionsRef = collection(db, 'community_questions');
      const questionsQuery = query(questionsRef, orderBy('text', 'asc'));
      const snapshot = await getDocs(questionsQuery);

      const questions: CommunityQuestionBase[] = [];
      snapshot.forEach((docSnap) => {
        const data = docSnap.data();
        questions.push({
          id: docSnap.id,
          text: data.text,
        });
      });

      return questions;
    } catch (error) {
      console.error('Error fetching community questions:', error);
      throw error;
    }
  }

  // ==================== TOOLS ====================

  async getAllTools(): Promise<Tool[]> {
    try {
      const toolsRef = collection(db, 'lessons');
      const toolsQuery = query(toolsRef, orderBy('bannerText', 'asc'));
      const snapshot = await getDocs(toolsQuery);

      const tools: Tool[] = [];
      snapshot.forEach((docSnap) => {
        const data = docSnap.data();
        tools.push({
          id: docSnap.id,
          bannerText: data.bannerText,
          bannerPath: data.bannerPath,
        });
      });

      return tools;
    } catch (error) {
      console.error('Error fetching tools:', error);
      throw error;
    }
  }

  // ==================== SUCCESS STORIES ====================

  async getAllSuccessStories(): Promise<SuccessStory[]> {
    try {
      const storiesRef = collection(db, 'community_success_stories');
      const storiesQuery = query(storiesRef, orderBy('title', 'asc'));
      const snapshot = await getDocs(storiesQuery);

      const stories: SuccessStory[] = [];
      snapshot.forEach((docSnap) => {
        const data = docSnap.data();
        stories.push({
          id: docSnap.id,
          title: data.title,
          featuredImageUrl: data.featuredImageUrl,
        });
      });

      return stories;
    } catch (error) {
      console.error('Error fetching success stories:', error);
      throw error;
    }
  }
}

export const pickersDataService = PickersDataService.getInstance();
